var _path, _path2, _path3, _path4, _ellipse, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 36,
    viewBox: "0 0 38 36",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3732 4.92578C8.38119 4.92578 1.90234 11.4046 1.90234 19.3967C1.90234 27.3887 8.38119 33.8676 16.3732 33.8676C24.3653 33.8676 30.8441 27.3887 30.8441 19.3967C30.8441 11.4046 24.3653 4.92578 16.3732 4.92578ZM11.3878 19.3967C11.3878 17.6426 12.2937 16.1001 13.6631 15.2115C13.0572 16.2885 12.7114 17.5317 12.7114 18.8562C12.7114 20.9401 13.5674 22.8239 14.9471 24.1752C12.8887 23.5617 11.3878 21.6545 11.3878 19.3967Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2427 0.631455C28.6506 3.48331 27.9584 5.76317 25.2527 7.61932",
    stroke: "black",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.748 5.24774C32.1681 8.06963 30.7461 9.98138 27.5723 10.8138",
    stroke: "black",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8053 10.6637C34.3016 13.121 32.3149 14.4363 29.047 14.1417",
    stroke: "black",
    strokeWidth: 3
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.5063,
    cy: 19.5069,
    rx: 10.9789,
    ry: 11.3331,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.8397,
    cy: 19.0682,
    r: 7.43733,
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.2650c27f261fa39b28569a4bd4ac1e3f.svg";
export { ForwardRef as ReactComponent };